/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

button.divi-toggle-button {
  color: variables.$text-color-black-medium-emphasis;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  &:hover {
    color: variables.$color-black;
  }

  &.selected {
    &.MuiButton-colorPrimary {
      color: variables.$color-primary;
    }
    &.MuiButton-colorSecondary {
      color: variables.$color-secondary;
    }
  }
}
